import axios from 'axios';
import baseService from '../shared/baseService';

const journalistService = () => baseService('journalists');
const getJournalistByQuery = (name: string, categoryId?: number, includeInactive?:boolean ) =>{
    let query = '';

    if (name && name != '')
        query = `?name=${name}`;

    if (categoryId && categoryId > 0) {
        if (query == '')
            query = `?categoryId=${categoryId}`;
        else 
            query += `&categoryId=${categoryId}`;
    }

    if (includeInactive != null) {
        if (query == '')
            query = `?includeInactive=${includeInactive}`;
        else 
            query += `&includeInactive=${includeInactive}`;
    }
        
    return axios.get(`journalists${query}`);
};

export default {
    journalistService,
    getJournalistByQuery
};